// Shared GraphQL queries for the gathering-kind UI.
//
// The list-shaped `GATHERINGS_QUERY` lives in ./queries.ts. This module is
// for the detail / room / lifecycle queries that operate on one gathering.

export const GATHERING_QUERY = /* GraphQL */ `
  query Gathering($id: ID!) {
    me { id }
    gathering(id: $id) {
      id title description
      kind location
      startsAt endsAt
      coverUrl
      visibility status
      circleId
      circle { id name }
      livekitRoomName
      host { id name firstName lastName pictureUrl }
      participants {
        id role joinedAt
        user { id name firstName lastName pictureUrl }
      }
      currentUserParticipant { id status joinedAt }
    }
  }
`;

export const GATHERING_ROOM_QUERY = /* GraphQL */ `
  query GatheringRoom($id: ID!) {
    me { id }
    gathering(id: $id) {
      id title description startsAt endsAt status livekitRoomName
      host { id }
      participants {
        id role
        user { id name firstName lastName pictureUrl }
      }
    }
  }
`;

export const JOIN_GATHERING_MUTATION = /* GraphQL */ `
  mutation JoinGathering($id: ID!) {
    joinGatheringRoom(gatheringId: $id) {
      token
      livekitUrl
    }
  }
`;

export const START_GATHERING_MUTATION = /* GraphQL */ `
  mutation StartGathering($id: ID!) {
    startGathering(id: $id) { id status }
  }
`;

export const END_GATHERING_MUTATION = /* GraphQL */ `
  mutation EndGathering($id: ID!) {
    endGathering(id: $id) { id status }
  }
`;

export const SEND_MESSAGE_MUTATION = /* GraphQL */ `
  mutation SendGatheringMessage($gatheringId: ID!, $content: String!) {
    sendGatheringMessage(gatheringId: $gatheringId, content: $content) {
      id content createdAt
      user { id name firstName lastName pictureUrl }
    }
  }
`;

export const SAVE_UTTERANCE_MUTATION = /* GraphQL */ `
  mutation SaveGatheringUtterance($gatheringId: ID!, $text: String!, $startedAt: DateTime!, $endedAt: DateTime!) {
    recordUtterance(gatheringId: $gatheringId, text: $text, startedAt: $startedAt, endedAt: $endedAt)
  }
`;

export const DELETE_GATHERING_MUTATION = /* GraphQL */ `
  mutation DeleteGathering($id: ID!) {
    deleteGathering(id: $id)
  }
`;

export const GATHERING_STATUS_POLL = /* GraphQL */ `
  query PollGatheringStatus($id: ID!) {
    gathering(id: $id) { status }
  }
`;
